import { render, staticRenderFns } from "./LeaderboardUserEloTable.vue?vue&type=template&id=15250108&scoped=true&"
import script from "./LeaderboardUserEloTable.vue?vue&type=script&lang=js&"
export * from "./LeaderboardUserEloTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15250108",
  null
  
)

export default component.exports